// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AlertController from "./alert_controller"
application.register("alert", AlertController)

import AutoScrollController from "./auto_scroll_controller"
application.register("auto-scroll", AutoScrollController)

import ChartController from "./chart_controller"
application.register("chart", ChartController)

import ChatController from "./chat_controller"
application.register("chat", ChatController)

import ChoicesController from "./choices_controller"
application.register("choices", ChoicesController)

import ChoroplethChartController from "./choropleth_chart_controller"
application.register("choropleth-chart", ChoroplethChartController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import ColorPickerController from "./color_picker_controller"
application.register("color-picker", ColorPickerController)

import ColorPickerFieldController from "./color_picker_field_controller"
application.register("color-picker-field", ColorPickerFieldController)

import DateRangePickerController from "./date_range_picker_controller"
application.register("date-range-picker", DateRangePickerController)

import DatepickerController from "./datepicker_controller"
application.register("datepicker", DatepickerController)

import DrawerController from "./drawer_controller"
application.register("drawer", DrawerController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import ElementRemoverController from "./element_remover_controller"
application.register("element-remover", ElementRemoverController)

import EmptyFieldCheckerController from "./empty_field_checker_controller"
application.register("empty-field-checker", EmptyFieldCheckerController)

import FiltersController from "./filters_controller"
application.register("filters", FiltersController)

import FormBlockerController from "./form_blocker_controller"
application.register("form-blocker", FormBlockerController)

import FormPreviewerController from "./form_previewer_controller"
application.register("form-previewer", FormPreviewerController)

import FrameLoaderController from "./frame_loader_controller"
application.register("frame-loader", FrameLoaderController)

import HidePanelController from "./hide_panel_controller"
application.register("hide-panel", HidePanelController)

import HideSectionController from "./hide_section_controller"
application.register("hide-section", HideSectionController)

import ImagePreviewController from "./image_preview_controller"
application.register("image-preview", ImagePreviewController)

import ImgFixerController from "./img_fixer_controller"
application.register("img-fixer", ImgFixerController)

import InputFillerController from "./input_filler_controller"
application.register("input-filler", InputFillerController)

import LightboxController from "./lightbox_controller"
application.register("lightbox", LightboxController)

import LocationSelectorController from "./location_selector_controller"
application.register("location-selector", LocationSelectorController)

import MarkdownController from "./markdown_controller"
application.register("markdown", MarkdownController)

import OwnerRezController from "./owner_rez_controller"
application.register("owner-rez", OwnerRezController)

import PopUpOpenerController from "./pop_up_opener_controller"
application.register("pop-up-opener", PopUpOpenerController)

import RatingController from "./rating_controller"
application.register("rating", RatingController)

import ReloadConfirmerController from "./reload_confirmer_controller"
application.register("reload-confirmer", ReloadConfirmerController)

import RevaExtensionCheckerController from "./reva_extension_checker_controller"
application.register("reva-extension-checker", RevaExtensionCheckerController)

import ScrollLockController from "./scroll_lock_controller"
application.register("scroll-lock", ScrollLockController)

import ScrollerController from "./scroller_controller"
application.register("scroller", ScrollerController)

import SectionTogglerController from "./section_toggler_controller"
application.register("section-toggler", SectionTogglerController)

import ShowSectionController from "./show_section_controller"
application.register("show-section", ShowSectionController)

import SortableController from "./sortable_controller"
application.register("sortable", SortableController)

import SubmitFormController from "./submit_form_controller"
application.register("submit-form", SubmitFormController)

import TableDeleterController from "./table_deleter_controller"
application.register("table-deleter", TableDeleterController)

import TabsController from "./tabs_controller"
application.register("tabs", TabsController)

import TippyController from "./tippy_controller"
application.register("tippy", TippyController)

import ToggleSectionController from "./toggle_section_controller"
application.register("toggle-section", ToggleSectionController)

import TruncateTextController from "./truncate_text_controller"
application.register("truncate-text", TruncateTextController)

import TurboLoaderController from "./turbo_loader_controller"
application.register("turbo-loader", TurboLoaderController)

import UrlValidatorController from "./url_validator_controller"
application.register("url-validator", UrlValidatorController)

import WindowCloserController from "./window_closer_controller"
application.register("window-closer", WindowCloserController)

import WordCloudController from "./word_cloud_controller"
application.register("word-cloud", WordCloudController)
